import { Component, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { AgendaRoteiroPontoFisico } from '../../comum/modelos/agenda-roteiro-ponto-fisico';
import { RoteiroService } from '../roteiro.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Data } from '../../comum/data/data';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-roteiro-interno',
    templateUrl: './roteiro-interno.component.html',
    styleUrls: ['./roteiro-interno.component.css']
})
export class RoteiroInternoComponent implements OnInit {
    @ViewChild('content') content: any;

    eventsModel: any;
    agendasRoteiroPontoFisico: AgendaRoteiroPontoFisico[];
    agendaRoteiroPontoFisico: AgendaRoteiroPontoFisico;
    agendas: any[];
    colors = ['#F0F8FF'
        , '#FAEBD7'
        , '#00FFFF'
        , '#7FFFD4'
        , '#F0FFFF'
        , '#F5F5DC'
        , '#FFE4C4'
        , '#FFEBCD'
        , '#0000FF'
        , '#8A2BE2'
        , '#A52A2A'
        , '#DEB887'
        , '#5F9EA0'
        , '#7FFF00'
        , '#D2691E'
        , '#FF7F50'
        , '#6495ED'
        , '#FFF8DC'
        , '#DC143C'
        , '#00FFFF'
        , '#00008B'
        , '#008B8B'
        , '#B8860B'
        , '#A9A9A9'
        , '#A9A9A9'
        , '#BDB76B'
        , '#8B008B'
        , '#556B2F'
        , '#FF8C00'
        , '#9932CC'
        , '#8B0000'
        , '#E9967A'
        , '#8FBC8F'
        , '#483D8B'
        , '#2F4F4F'
        , '#2F4F4F'
        , '#00CED1'
        , '#9400D3'
        , '#FF1493'
        , '#00BFFF'
        , '#696969'
        , '#696969'
        , '#1E90FF'
        , '#B22222'
        , '#FFFAF0'
        , '#228B22'
        , '#FF00FF'
        , '#DCDCDC'
        , '#F8F8FF'
        , '#FFD700'
        , '#DAA520'
        , '#808080'
        , '#808080'
        , '#008000'
        , '#ADFF2F'
        , '#F0FFF0'
        , '#FF69B4'
        , '#CD5C5C'
        , '#4B0082'
        , '#FFFFF0'
        , '#F0E68C'
        , '#E6E6FA'
        , '#FFF0F5'
        , '#7CFC00'
        , '#FFFACD'
        , '#ADD8E6'
        , '#F08080'
        , '#E0FFFF'
        , '#FAFAD2'
        , '#D3D3D3'
        , '#D3D3D3'
        , '#90EE90'
        , '#FFB6C1'
        , '#FFA07A'
        , '#20B2AA'
        , '#87CEFA'
        , '#778899'
        , '#778899'
        , '#B0C4DE'
        , '#FFFFE0'
        , '#00FF00'
        , '#32CD32'
        , '#FAF0E6'
        , '#FF00FF'
        , '#800000'
        , '#66CDAA'
        , '#0000CD'
        , '#BA55D3'
        , '#9370DB'
        , '#3CB371'
        , '#7B68EE'
        , '#00FA9A'
        , '#48D1CC'
        , '#C71585'
        , '#191970'
        , '#F5FFFA'
        , '#FFE4E1'
        , '#FFE4B5'
        , '#FFDEAD'
        , '#000080'
        , '#FDF5E6'
        , '#808000'
        , '#6B8E23'
        , '#FFA500'
        , '#FF4500'
        , '#DA70D6'
        , '#EEE8AA'
        , '#98FB98'
        , '#AFEEEE'
        , '#DB7093'
        , '#FFEFD5'
        , '#FFDAB9'
        , '#CD853F'
        , '#FFC0CB'
        , '#DDA0DD'
        , '#B0E0E6'
        , '#800080'
        , '#663399'
        , '#FF0000'
        , '#BC8F8F'
        , '#8B4513'
        , '#FA8072'
        , '#F4A460'
        , '#2E8B57'
        , '#FFF5EE'
        , '#A0522D'
        , '#C0C0C0'
        , '#87CEEB'
        , '#6A5ACD'
        , '#708090'
        , '#708090'
        , '#FFFAFA'
        , '#00FF7F'
        , '#4682B4'
        , '#D2B48C'
        , '#008080'
        , '#D8BFD8'
        , '#FF6347'
        , '#40E0D0'
        , '#EE82EE'
        , '#F5DEB3'
        , '#FFFFFF'
        , '#F5F5F5'
        , '#FFFF00'
        , '#9ACD32'
    ];

    calendarOptions = {
        fixedWeekCount: false,
        defaultDate: new Date(),
        editable: false,
        eventLimit: false,
        weekends: true,
        selectable: true,
        selectMirror: true,
        displayEventTime: false,
        buttonText: {
            today: 'Hoje',
            month: 'M\u00eas',
            agendaWeek: 'Semana',
            agendaDay: 'Dia'
        },
        customButtons: {
            myCustomButton: {
                text: 'Exportar',
                click: () => this.createIcsFile()
            }
        },
        header: {
            right: 'prev,next today myCustomButton',
            center: 'title',
            left: 'month,agendaWeek,agendaDay'
        },
        events: []
        , dayClick: (date, jsEvent, activeView) => {
            this.dayClick(date, jsEvent, activeView);
        },
        eventDragStart: (timeSheetEntry, jsEvent, ui, activeView) => {
            this.eventDragStart(
                timeSheetEntry, jsEvent, ui, activeView
            );
        },
        eventDragStop: (timeSheetEntry, jsEvent, ui, activeView) => {
            this.eventDragStop(
                timeSheetEntry, jsEvent, ui, activeView
            );
        },
        eventClick: (timeSheetEntry, jsEvent, ui, activeView) => {
            this.eventClick(
                timeSheetEntry, jsEvent, ui, activeView
            );
        },
        select: (timeSheetEntry, jsEvent, ui, activeView) => {
            this.handleDateSelect.bind(timeSheetEntry, jsEvent, ui, activeView);
        },
        locale: 'pt-br'
    };


    constructor (
        private _roteiroService: RoteiroService,
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService,
        private modalService: NgbModal,
        private data: Data,
        private datePipe: DatePipe) {
        this.agendasRoteiroPontoFisico = new Array<AgendaRoteiroPontoFisico>();
        this.agendas = new Array<any>();
    }

    ngOnInit() {
        const idRoteiro = this._activatedRoute.snapshot.params['id'];
        this._roteiroService.obterAgendasRoteiroPontoFisicoHttp(idRoteiro).subscribe(agendasRpf => {
            this.agendasRoteiroPontoFisico = agendasRpf;
            const mapCores = new Map();
            let i = 0;
            this.agendasRoteiroPontoFisico.forEach(agenda => {
                if (mapCores.has(agenda.nomePontoFisico)) {
                    agenda.cor = mapCores.get(agenda.nomePontoFisico);
                } else {
                    agenda.cor = this.colors[i];
                    mapCores.set(agenda.nomePontoFisico, this.colors[i]);
                    i++;
                }
                this.agendas.push({
                    id: agenda.idAgendaRoteiroPontoFisico,
                    title: agenda.nomePontoFisico,
                    start: new Date(agenda.dataAgenda),
                    color: agenda.cor
                });
            });
            this.calendarOptions.events = [...this.agendas];
            $('#calendar').fullCalendar('renderEvents', this.calendarOptions.events, true);
            $('#calendar').fullCalendar('rerenderEvents');

        });
    }

    createIcsFile() {
        let ics = 'BEGIN:VCALENDAR\n'
            + 'VERSION:2.0\n'
            + 'PRODID:-//Flag//Homini Sistemas//EN\n'
            + 'CALSCALE:GREGORIAN\n'
            + 'X-WR-CALNAME;VALUE=TEXT:Agendas Roteiro\n';
        this.agendasRoteiroPontoFisico.forEach(agenda => {
            const data = new Date(agenda.dataAgenda);
            ics = ics + 'BEGIN:VEVENT\n';
            ics = ics + 'SUMMARY:' + agenda.nomePontoFisico + '\n';
            ics = ics + 'DESCRIPTION:' + agenda.nomePontoFisico + '\n';
            ics = ics + 'DTSTART:' + this.datePipe.transform(data, 'yyyyMMdd') + '\n';
            ics = ics + 'UID:' + agenda.idAgendaRoteiroPontoFisico + '@hominisistemas.com.br\n';
            ics = ics + 'END:VEVENT\n';
        });
        ics = ics + 'END:VCALENDAR';

        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        if (Blob !== undefined) {
            const blob = new Blob([ics], { type: 'text/plain' });
            link.setAttribute('href', URL.createObjectURL(blob));
        } else {
            link.setAttribute('href', 'data:text/plain,' + encodeURIComponent(ics));
        }
        link.setAttribute('download', 'export.ics');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    onCalendarInit(initialized: boolean) {
        console.log('Calendar initialized');
    }

    dayClick(date, jsEvent, activeView) {
        console.log('day click');
    }

    eventDragStart(timeSheetEntry, jsEvent, ui, activeView) {
        console.log('event drag start');
    }

    eventDragStop(timeSheetEntry, jsEvent, ui, activeView) {
        console.log('event drag end');
    }

    eventClick(timeSheetEntry, jsEvent, ui, activeView) {
        // console.log(timeSheetEntry.start.format('DD/MM/YYYY'));
        this.agendaRoteiroPontoFisico = this.agendasRoteiroPontoFisico.find(
            agenda => agenda.idAgendaRoteiroPontoFisico === timeSheetEntry.id);
        this.data.storage = {
            'agendaRoteiroPontoFisico': this.agendaRoteiroPontoFisico
        };
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalCadastroRoteiroInterno',
            size: 'lg'
        };
        this.modalService.open(this.content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });

    }

    handleDateSelect(timeSheetEntry, jsEvent, ui, activeView) {
        console.log(timeSheetEntry);
        console.log(jsEvent);
        console.log(ui);
        console.log(activeView);
        const title = prompt('Please enter a new title for your event');
        /*const calendarApi = selectInfo.view.calendar;

        calendarApi.unselect(); // clear date selection

        if (title) {
            calendarApi.addEvent({
                title,
                start: selectInfo.startStr,
                end: selectInfo.endStr,
                allDay: selectInfo.allDay
            });
        }*/
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/roteiro-interno/roteiro-interno.component.ts